/******************************************************************************************
 * TIP: Use XML documentation comments so they work with Visual Studio Intellisense:
 * http://msdn.microsoft.com/en-us/library/bb514138.aspx 
 * Check out the "JavaScript vsdoc Generator" Visual Studio extension to make it easy:
 * https://visualstudiogallery.msdn.microsoft.com/0cb7304b-ad78-4283-ba2b-42804657fcdd
 ******************************************************************************************/



// Plug-in initialization functions that should run on every page when it loads 
$(function () {
    // The following supports anti request forgery tokens for AJAX POSTs.  
    $.ajaxSetup({
        beforeSend: function (xhr) {
            var securityToken = $('#__AjaxAntiForgeryForm input[name=__RequestVerificationToken]').val();
            xhr.setRequestHeader("__RequestVerificationToken", securityToken);
        }
    });

    // set up date pickers
    $('.datepicker').pickadate({
        format: 'mm/dd/yyyy',
        formatSubmit: 'mm/dd/yyyy'
    });
    $('.datepicker').removeAttr('readonly'); //required for validation to work on the field
});

// Put your application's custom functions in a JavaScript "namespace" to avoid collisions
// with other libraries
export const TaxInfo = new function () {

    // Use the format below for adding global methods
    this.HelperMethod = function (param1, param2) {
        //logic goes here
    };

};


//this function returns a URL parameter value (with case preserved) regardless of the case of the URL parameter name
export function GetUrlParameterValue(sParam) {

    var sPageURL = window.location.search.substring(1);

    var sURLVariables = sPageURL.split('&');

    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0].toLowerCase() == sParam.toLowerCase()) {
            return sParameterName[1];
        }
    }

};

window.TaxInfo = TaxInfo;
window.GetUrlParameterValue = GetUrlParameterValue;
